import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import theme from './VideoConference.scss';

export default class VideoStream extends Component {
  static propTypes = {
    stream: PropTypes.any.isRequired,
    height: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    width: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    style: PropTypes.object,
    className: PropTypes.string,
    muted: PropTypes.bool,
    volume: PropTypes.number,
  };

  static defaultProps = {
    muted: false,
    volume: 0.5,
    className: '',
    width: '100%',
    height: '100%',
    style: {},
  };

  componentDidMount() {
    this.audioEl.volume = 0.5;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.volume !== this.props.volume) {
      this.audioEl.volume = newProps.volume / 100;
    }
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.stream, nextProps.stream) || !isEqual(this.props.height, nextProps.height);
  }

  render() {
    const { stream } = this.props;
    if (!stream) return null;

    return (
      <div className={ theme.root }>
        <video
          autoPlay
          playsInline
          muted={ true }
          width={ this.props.width }
          height={ this.props.height }
          className={ this.props.className }
          style={ this.props.style }
          ref={ ref => {
            this.videoEl = ref;
            if (ref) this.videoEl.srcObject = stream;
          } }
        />

        <audio
          playsInline
          autoPlay
          muted={ this.props.muted }
          ref={ ref => {
            this.audioEl = ref;
            if (ref) this.audioEl.srcObject = stream;
          } }
        />
      </div>
    );
  }
}
